import { CountryCode, NUMBER_3 } from '~shared/constants';
import { PaypalServicePaymentMethods, ServicePaymentMethodTypes } from '../models';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
export const CHECKOUT_STATE_ID = 'checkout';

export enum AddressType {
  Billing = 'billing',
  Shipping = 'shipping',
}

export enum PaymentMethodOptions {
  NONE = '',
  RatePayInvoice = 'ratePayInvoice',
  CreditCard = 'creditCard',
  RatePayDirectDebit = 'ratePayDirectDebit',
  Paypal = 'paypal',
  DirectEbanking = 'directEbanking',
  IDeal = 'ideal',
  PayPal_ins_FR = 'paypal_ins_fr',
  PayPal_ins_ES = 'paypal_ins_es',
  PayPal_ins_IT = 'paypal_ins_it',
  SepaDebitDirect = 'sepadirectdebit',
  Billie = 'klarna_b2b',
  MetroInvoice = 'metro_invoice',
  PayByBank = 'paybybank',
}

export const PayPalPayLaterMethods: (PaymentMethodOptions | ServicePaymentMethodTypes)[] = [
  PaymentMethodOptions.PayPal_ins_FR,
  PaymentMethodOptions.PayPal_ins_ES,
  PaymentMethodOptions.PayPal_ins_IT,
];
export type PaypalPaymentMethods =
  | PaymentMethodOptions.PayPal_ins_FR
  | PaymentMethodOptions.Paypal
  | PaypalServicePaymentMethods;

export enum PaymentMethodBrands {
  Paypal = 'paypal',
  Visa = 'visa',
  MasterCard = 'mastercard',
  Sofort = 'sofort',
  Ratepay = 'ratepay',
  DirectDebit = 'directDebit',
  Ideal = 'ideal',
  CartesBancaires = 'cartesbancaires',
  Billie = 'klarna_b2b',
  MetroInvoice = 'metro_invoice',
}
export const PaymentNewTag: {
  [key in PaymentMethodOptions]?: Date;
} = (() => {
  const nineDec23 = new Date('09-12-2023');
  const additional3Month = new Date(nineDec23.setMonth(nineDec23.getMonth() + NUMBER_3));
  return {
    [PaymentMethodOptions.PayPal_ins_FR]: additional3Month,
    [PaymentMethodOptions.PayPal_ins_IT]: additional3Month,
    [PaymentMethodOptions.PayPal_ins_ES]: additional3Month,
  } as const;
})();

export enum PaymentMethodDisabledReasons {
  OrderTotalIsBelowMaxAmount = 'CHECKOUT.PAYMENT.ORDER_BELOW_MAX_AMOUNT',
}
export enum RatePayStatuses {
  Blocked = 'BLOCKED',
  Removed = 'REMOVED',
  Ref3DSNotAuthenticatedCode = '11',
  Ref3DSNotAuthenticatedReason = '3d-secure: Authentication failed',
  Ref3DSAuthenticationRequired = 'Authentication required',
  Ref3DSNotAuthenticated = '3D Not Authenticated',
  RefCardNotSupported = 'Could not find an acquirer account for the provided txvariant',
  //
  RefZeroCode = '0',
  Ref730 = '730',
  Ref720 = '720',
  Ref721 = '721',
  Ref703 = '703',
  Ref3DSNotAuthenticatedCode38 = '38',
  Ref905_1 = '905_1',
  Ref2100 = '2100',
  Ref2101 = '2101',
  Ref200 = '200',
  Ref2110 = '2110',
  Ref2 = '2',
  Ref6 = '6',
  Ref12 = '12',
  Ref20 = '20',
  Ref23 = '23',
  Ref24 = '24',
  Ref25 = '25',
  Ref27 = '27',
  Ref28 = '28',
  Ref31 = '31',
  Ref39 = '39',
  Ref103 = '103',
  Ref8 = '8',
  Ref101 = '101',
  Ref1000 = '1000',
  Ref1001 = '1001',
}
export const FailedRefusalCodes = [
  RatePayStatuses.Ref2,
  RatePayStatuses.Ref6,
  RatePayStatuses.Ref12,
  RatePayStatuses.Ref20,
  RatePayStatuses.Ref23,
  RatePayStatuses.Ref24,
  RatePayStatuses.Ref25,
  RatePayStatuses.Ref27,
  RatePayStatuses.Ref28,
  RatePayStatuses.Ref31,
  RatePayStatuses.Ref39,
  RatePayStatuses.Ref103,
  RatePayStatuses.Ref8,
  RatePayStatuses.Ref101,
  RatePayStatuses.Ref1001,
];
export enum PaymentErrorMessages {
  '3DS1_WRONG_LOG_IN' = 'CHECKOUT.ERROR.3DS1.WRONG_LOG_IN',
  PAYMENT_FAILED_MESSAGE = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_MESSAGE',
  CARD_NOT_SUPPORTED = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_CARD_NOT_SUPPORTED',
  FAILED_BILLING_ADDRESS = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_BILLING_ADDRESS',
  FAILED_DELIVERY_ADDRESS = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_DELIVERY_ADDRESS',
  TECHNICAL_ERROR = 'CHECKOUT.REVIEW.ERROR.PAYMENT_TECHNICAL_ERROR',
  BANK_NOT_VERIFIED = 'CHECKOUT.REVIEW.ERROR.PAYMENT_BANK_NOT_VERIFIED',
  PAYMENT_FAILED_GENERIC_MESSAGE = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_GENERIC_MESSAGE',
  NOT_ENOUGH_BALANCE = 'CHECKOUT.REVIEW.ERROR.NOT_ENOUGH_BALANCE',
  CVC_DECLINED = 'CHECKOUT.REVIEW.ERROR.CVC_DECLINED',
  WITHDRAWAL_AMOUNT_EXCEEDED = 'CHECKOUT.REVIEW.ERROR.WITHDRAWAL_AMOUNT_EXCEEDED',
  INVALID_CARD_NUMBER = 'CHECKOUT.REVIEW.ERROR.INVALID_CARD_NUMBER',
  WRONG_CVC_LENGTH = 'CHECKOUT.REVIEW.ERROR.WRONG_CVC_LENGTH',
  TRANSACTION_NOT_PERMITTED = 'CHECKOUT.REVIEW.ERROR.TRANSACTION_NOT_PERMITTED',
  DECLINED_GENERIC = 'CHECKOUT.REVIEW.ERROR.DECLINED_GENERIC',
  EXPIRED_CARD = 'CHECKOUT.REVIEW.ERROR.EXPIRED_CARD',
  //Assisted sales - PLEASE ADD A COUNTRY POSTFIX (.FRANCE .GERMANY)
  ASSISTED_SALES_GENERIC_ERROR = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_GENERIC.ASSISTED_SALES',
  ASSISTED_SALES_3D_NOT_AUTHENTICATED = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_3D_NOT_AUTHENTICATED.ASSISTED_SALES',
  ASSISTED_SALES_PAYMENT_REFUSED_ERROR = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_REFUSED.ASSISTED_SALES',
  ASSISTED_SALES_PAYMENT_AMOUNT_EXCEEDED_BALANCE = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_AMOUNT_EXCEED.ASSISTED_SALES',
  ASSISTED_SALES_PAYMENT_FRAUD = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_CC_FRAUD.ASSISTED_SALES',
  ASSISTED_SALES_SUSPECTED_FRAUD = 'CHECKOUT.REVIEW.ERROR.PAYMENT_FAILED_SUSPECTED_FRAUD.ASSISTED_SALES',
  ASSISTED_SALES_WITHDRAWAL_AMOUNT_EXCEEDED = 'CHECKOUT.REVIEW.ERROR.WITHDRAWAL_AMOUNT_EXCEEDED.ASSISTED_SALES',
}

export const TranslationMarketKey: Record<CountryCode, string> = {
  de: 'GERMANY',
  es: 'SPAIN',
  fr: 'FRANCE',
  it: 'ITALY',
  nl: 'NETHERLANDS',
  pt: 'PORTUGAL',
} as const;

export const PaymentFailedAssistedSalesErrorMap: Partial<Record<number, PaymentErrorMessages>> = {
  11: PaymentErrorMessages.ASSISTED_SALES_3D_NOT_AUTHENTICATED,
  2: PaymentErrorMessages.ASSISTED_SALES_PAYMENT_REFUSED_ERROR,
  12: PaymentErrorMessages.ASSISTED_SALES_PAYMENT_AMOUNT_EXCEEDED_BALANCE,
  20: PaymentErrorMessages.ASSISTED_SALES_PAYMENT_FRAUD,
  31: PaymentErrorMessages.ASSISTED_SALES_SUSPECTED_FRAUD,
  28: PaymentErrorMessages.ASSISTED_SALES_WITHDRAWAL_AMOUNT_EXCEEDED,
} as const;

export const PaymentFailedSpecifiedMessageMap = {
  [RatePayStatuses.Ref2110]: PaymentErrorMessages.BANK_NOT_VERIFIED,
  [RatePayStatuses.Ref1000]: PaymentErrorMessages.TECHNICAL_ERROR,
  [RatePayStatuses.Ref2100]: PaymentErrorMessages.FAILED_BILLING_ADDRESS,
  [RatePayStatuses.Ref2101]: PaymentErrorMessages.FAILED_DELIVERY_ADDRESS,
  [RatePayStatuses.Ref6]: PaymentErrorMessages.EXPIRED_CARD,
  [RatePayStatuses.Ref8]: PaymentErrorMessages.INVALID_CARD_NUMBER,
  [RatePayStatuses.Ref101]: PaymentErrorMessages.INVALID_CARD_NUMBER,
  [RatePayStatuses.Ref12]: PaymentErrorMessages.NOT_ENOUGH_BALANCE,
  [RatePayStatuses.Ref23]: PaymentErrorMessages.TRANSACTION_NOT_PERMITTED,
  [RatePayStatuses.Ref24]: PaymentErrorMessages.CVC_DECLINED,
  [RatePayStatuses.Ref27]: PaymentErrorMessages.DECLINED_GENERIC,
  [RatePayStatuses.Ref28]: PaymentErrorMessages.WITHDRAWAL_AMOUNT_EXCEEDED,
  [RatePayStatuses.Ref103]: PaymentErrorMessages.WRONG_CVC_LENGTH,
};
export const CHECKOUT_LOCALSTORAGE_KEY = 'app-checkout/storage';
export const CHECKOUT_LOCALSTORAGE_KEY_PAYMENT = 'app-checkout/p';
export const CHECKOUT_LOCALSTORAGE_KEY_3DS = 'app-checkout/3ds';
export const CHECKOUT_LOCALSTORAGE_TMP_ADRS = 'app-checkout/tmp-adrs';
export const CHECKOUT_LOCALSTORAGE_TMP_EMAIL_CONSENT = 'app-checkout/tmp-consent';
export const CHECKOUT_LOCALSTORAGE_TMP_CUSTOMER_PURCHASE_HISTORY = 'app-checkout/tmp-customer-purchase-history';
export const CHECKOUT_SESSION_STORAGE_TMP_DISCOUNT_CODE = 'app-checkout/tmp-discount-code';
export const CHECKOUT_LOCALSTORAGE_TMP_ORDER_NUMBER = 'app-checkout/tmp-order-number';
export const CHECKOUT_SESSION_STORAGE_TMP_CRITEO_TRANSACTION_DATA = 'app-checkout/tmp-criteo-transaction-data';
export const CHECKOUT_SESSION_STORAGE_TMP_TAX_NUMBER = 'app-checkout/tmp-tax-number';
export const CHECKOUT_SESSION_STORAGE_TMP_ZENLOOP_DATA = 'app-checkout/tmp-zenloop-data';
export const CHECKOUT_SESSION_STORAGE_TMP_VAT_ID = 'app-checkout/tmp-vat-id';
export const CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_ID = 'app-checkout/ravelin-device-id';
export const CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_FF = 'app-checkout/ravelin-device-ff';
export const CHECKOUT_LOCALSTORAGE_REACT_PHONENUMBER = '@metromarkets/phoneNumber';
export const CHECKOUT_LOCALSTORAGE_PURCHASE_ORDER_NUMBER = 'purchaseOrderNumber';
export const CHECKOUT_SESSION_STORAGE_COMBINED_CUSTOMER_CONSENT_PHONE = 'app-checkout/tmp-combined-customer-consent-phone-key';
export const CHECKOUT_SESSION_STORAGE_COMBINED_CUSTOMER_CONSENT_EMAIL = 'app-checkout/tmp-combined-customer-consent-email-key';
export const CHECKOUT_SESSION_STORAGE_COMBINED_CUSTOMER_CONSENT_COMBINE = 'app-checkout/tmp-combined-customer-consent-combined-key';
export const CHECKOUT_SESSION_STORAGE_COMBINED_CUSTOMER_OPT_OUT_CHECKBOX = 'app-checkout/tmp-customer-opt-out-checkbox';

export const ADYEN_DROPIN_TIMEOUT = 200;
export const ADYEN_CHANNEL = 'Web';

export const LAST_PAYMENT_METHODS_USED = {
  'Rate-pay': 'ratePayInvoice',
  'credit-card': 'creditCard',
  'Rate-pay-dd': 'ratePayDirectDebit',
  paypal: 'paypal',
  sofort: 'directEbanking',
  [PaymentMethodOptions.SepaDebitDirect]: PaymentMethodOptions.SepaDebitDirect,
  [PaymentMethodOptions.PayPal_ins_ES]: PaymentMethodOptions.PayPal_ins_ES,
  [PaymentMethodOptions.PayPal_ins_IT]: PaymentMethodOptions.PayPal_ins_IT,
  [PaymentMethodOptions.PayPal_ins_FR]: PaymentMethodOptions.PayPal_ins_FR,
  [PaymentMethodOptions.IDeal]: PaymentMethodOptions.IDeal,
  [PaymentMethodOptions.MetroInvoice]: PaymentMethodOptions.MetroInvoice,
  [PaymentMethodOptions.CreditCard]: PaymentMethodOptions.CreditCard,
  [PaymentMethodOptions.RatePayInvoice]: PaymentMethodOptions.RatePayInvoice,
} as const;

export const PAYPAL_IFRAME_STYLES_CONFIG = {
  layout: 'horizontal',
  size: 'small',
  shape: 'rect',
  height: 44,
  tagline: 'true',
  branding: 'true',
  color: 'gold',
  label: 'buynow',
};

export const CHECKOUT_REDUCED_STEPPER_EXPERIMENT = 'checkout_reduced_stepper';
export const SUBSIDIARY_NEEDS_APPROVAL = 'SUBSIDIARY_NEEDS_APPROVAL';

export const newCheckoutGA4Events = [
  GATrackingEventType.AddShippingInfo,
  GATrackingEventType.AddPaymentInfo,
  GATrackingEventType.ReviewOrderInfo,
];

export const PAYMENT_PROCESSING_TIMEOUT = 15_000;

export const CART_PAGE_ALIAS = 'cart';

export const AdyenCreditTypeMap = {
  mc: 'MasterCard',
} as const;